import { render, staticRenderFns } from "./permisos.view.vue?vue&type=template&id=5ef1d9a3"
import script from "./permisos.view.vue?vue&type=script&lang=js"
export * from "./permisos.view.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports